import React, { useContext } from "react"
import { Card, Grid } from "@mui/material"
import __t from "../../../lib/traduzioni"
import BSSPreventivoContext from "../../../contexts/BSSPreventivoContext"
import { FormDatiFatturazione } from "../../account/DatiFatturazione"

const FrammentoFatturazione = ({methods, classes}) => {

    const {tipiPersone = [], nazioni = [], isodefault = "IT"} = useContext(BSSPreventivoContext);

    return (
        <>
            <Grid item xs={12} className={classes.formGroupBox}>
                <Card>
                    <FormDatiFatturazione {...{
                        methods,
                        classes,
                        tipiPersone,
                        nazioni,
                        isodefault,
                        inPreventivo: true
                    }} />
                </Card>
            </Grid>
        </>
    )
}

export default FrammentoFatturazione